// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
export { NGRoomsAndGuests } from './NGRoomsAndGuests';
export { NGRoomsAndGuests as RoomsAndGuests } from './NGRoomsAndGuests';
